"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailValidator = void 0;
class EmailValidator {
    static isValid(email) {
        if (!email || typeof email !== 'string') {
            return false;
        }
        const trimmed = email.trim();
        // Check length constraints
        if (trimmed.length > this.MAX_EMAIL_LENGTH) {
            return false;
        }
        // Check basic format
        if (!this.EMAIL_REGEX.test(trimmed)) {
            return false;
        }
        // Check local and domain parts
        const [local, domain] = trimmed.split('@');
        if (!local || !domain) {
            return false;
        }
        if (local.length > this.MAX_LOCAL_LENGTH) {
            return false;
        }
        if (domain.length > this.MAX_DOMAIN_LENGTH) {
            return false;
        }
        return true;
    }
    static normalize(email) {
        if (!email || typeof email !== 'string') {
            return '';
        }
        return email.toLowerCase().trim();
    }
    static validate(email) {
        const normalized = this.normalize(email);
        const isValid = this.isValid(normalized);
        return {
            isValid,
            value: normalized,
            error: isValid ? undefined : 'Invalid email format'
        };
    }
    static validateBatch(emails) {
        return emails.map(email => this.validate(email));
    }
}
exports.EmailValidator = EmailValidator;
EmailValidator.EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
EmailValidator.MAX_EMAIL_LENGTH = 254;
EmailValidator.MAX_LOCAL_LENGTH = 64;
EmailValidator.MAX_DOMAIN_LENGTH = 255;
